/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXUpIcon16Light = forwardRef('DataChartBarsXUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.5 1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M10 3.5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7Z" }),
        React.createElement("path", { d: "M6.5 5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M3.5 7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M1.5 13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1h-13Z" })));
});
